import { createApp } from "vue";
import { COMMIT, VERSION } from "./version";

// Boot
console.log(`T3Admin ${VERSION} (${COMMIT})`);
console.log(`MODE: ${import.meta.env.MODE}`);

import setupGlobals from "./globals";
import setupDirectives from "./helpers/directives";

import setupMixins from "./mixins";
import router from "./router";
import pinia from "./stores";
import "./helpers/filters";

import App from "./App.vue";

import setupComponents from "./components";
import setupFormatters from "./helpers/formatters";

const app = createApp(App);
app.use(router);
app.use(pinia);

setupMixins(app);
setupGlobals(app);
setupComponents(app);
setupFormatters(app);
setupDirectives(app);

// Initialize App
import { useAuthStore } from "@/stores/auth";

const authStore = useAuthStore(pinia);
authStore.initAuth();

import { useRoutesStore } from "@/stores/routes";

const routesStore = useRoutesStore(pinia);
routesStore.initialize(router);

app.config.errorHandler = (err, ..._) => {
    if (err === "go to login") {
        authStore.clearAuth();
        router.replace({ path: "/login" });
    }
};

app.mount("#app");
